import { SET_SHOW_SIDEBAR_CALENDER } from "./types";

export const setShowSidebarCalendar = (boolean) => {
    return ({ type: SET_SHOW_SIDEBAR_CALENDER, payload: boolean })
};